
import { Button } from "@oc-labs/wt-storybook";
import { Plus } from "lucide-react";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import useCompany from "../../../hooks/useCompany";
import CreateCompanyModal from "./components/CreateCompanyModal";
import useModal from "../../../hooks/useModal";

export default function AdminCompaniesView() {
  const { getAllCompanies } = useCompany();
  const [companies, setCompanies] = useState([]);
  const [loading, setLoading] = useState(true);
  const createCompanyModal = useModal("admin-create-company");
  const navigate = useNavigate();

  useEffect(() => {
    const fetchCompanies = async () => {
      setLoading(true);
      const data = await getAllCompanies();
      setCompanies(data || []);
      setLoading(false);
    };
    fetchCompanies();
  }, []);

  return (
    <div className="2xl:p-6 p-3">
      <div className="flex justify-between items-center mb-4">
        <h2 className="2xl:text-xl text-base font-medium">All companies</h2>
        <div className="flex">
          <Button
            type="secondary"
            size="small"
            onClick={() => createCompanyModal.open()}
            icon={<Plus size={16} />}
            className="whitespace-nowrap"
          >
            Create Company
          </Button>
        </div>
      </div>

      <div className="rounded-lg shadow overflow-hidden">
        <table className="w-full bg-white table-fixed">
          <thead className="bg-gray-100 uppercase">
            <tr>
              <th className="2xl:py-3 py-2 2xl:px-6 px-3 text-left text-xs font-medium tracking-wider w-[30%]">ID</th>
              <th className="2xl:py-3 py-2 2xl:px-6 px-3 text-left text-xs font-medium tracking-wider w-[20%]">Name</th>
              <th className="2xl:py-3 py-2 2xl:px-6 px-3 text-left text-xs font-medium tracking-wider w-[10%]">Users</th>
              <th className="2xl:py-3 py-2 2xl:px-6 px-3 text-left text-xs font-medium tracking-wider w-[25%]">Owner</th>
              <th className="2xl:py-3 py-2 2xl:px-6 px-3 text-left text-xs font-medium tracking-wider w-[15%]">Created At</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-200">
            {loading ? (
              <tr><td colSpan={5} className="2xl:py-4 py-2.5 2xl:px-6 px-3 text-center">Loading...</td></tr>
            ) : companies.length === 0 ? (
              <tr><td colSpan={5} className="2xl:py-4 py-2.5 2xl:px-6 px-3 text-center">No companies found</td></tr>
            ) : (
              companies.map((company) => (
                <tr
                  key={company.id}
                  className="hover:bg-gray-50 cursor-pointer"
                  onClick={() => navigate(`/admin/companies/${company.id}`)}
                >
                  <td className="2xl:py-4 py-2.5 2xl:px-6 px-3 text-xs truncate">{company.id}</td>
                  <td className="2xl:py-4 py-2.5 2xl:px-6 px-3 text-xs truncate">{company.name}</td>
                  <td className="2xl:py-4 py-2.5 2xl:px-6 px-3 text-xs truncate">{company.totalMembers ?? '-'}</td>
                  <td className="2xl:py-4 py-2.5 2xl:px-6 px-3 text-xs truncate">{company.owner?.email || '-'}</td>
                  <td className="2xl:py-4 py-2.5 2xl:px-6 px-3 text-xs truncate">{company.createdAt ? new Date(company.createdAt).toLocaleDateString() : '-'}</td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}